import {SDFBlurCopNode} from './../../../../../../../@polygonjs/polygonjs/src/engine/nodes/cop/SDFBlur';
import {Vector3Param} from './../../../../../../../@polygonjs/polygonjs/src/engine/params/Vector3';
import {NodePathParam} from './../../../../../../../@polygonjs/polygonjs/src/engine/params/NodePath';
import {RayMarchingBuilderMatNode} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/mat/RayMarchingBuilder';
import {NodeContextMenuRegister, DropDownMenuEntryWithCallback} from '../BaseSetup';
import {ParamType} from '../../../../../../../@polygonjs/polygonjs/src/engine/poly/ParamType';
import {NodeContext} from '../../../../../../../@polygonjs/polygonjs/src/engine/poly/NodeContext';
import {CopType} from '../../../../../../../@polygonjs/polygonjs/src/engine/poly/registers/nodes/types/Cop';
import {SDFFromObjectCopNode} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/cop/SDFFromObject';
import {SDFFromUrlCopNode} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/cop/SDFFromUrl';

export const MAT_RAYMARCHING_BUILDER_LABEL = {UPDATE_TEXTURE_SDF_BOUNDS: 'Update Texture SDF Bounds'};

export const rayMarchingBuilderActorNodeContextMenu: NodeContextMenuRegister<
	typeof RayMarchingBuilderMatNode,
	RayMarchingBuilderMatNode
> = {
	nodeClass: RayMarchingBuilderMatNode,
	setupFunc: (node) => {
		const bindTextureSDFBounds: DropDownMenuEntryWithCallback = {
			entry: {id: 'updateTextureSDFBounds', label: MAT_RAYMARCHING_BUILDER_LABEL.UPDATE_TEXTURE_SDF_BOUNDS},
			callback: () => {
				const spareParams = node.params.spare;

				const nodePathParams: NodePathParam[] = [];
				for (let spareParam of spareParams) {
					if (spareParam.type() == ParamType.NODE_PATH) {
						nodePathParams.push(spareParam as NodePathParam);
					}
				}

				async function _updateNodePathBoundParams(nodePathParam: NodePathParam) {
					if (nodePathParam.isDirty()) {
						await nodePathParam.compute();
					}
					const nodeTarget = nodePathParam.value.nodeWithContext(NodeContext.COP);
					if (!nodeTarget) {
						return;
					}
					const nodeType = nodeTarget.type();
					if (
						![CopType.SDF_BLUR, CopType.SDF_FROM_OBJECT, CopType.SDF_FROM_URL].includes(nodeType as CopType)
					) {
						return;
					}
					const sdfNode = nodeTarget as SDFFromObjectCopNode | SDFFromUrlCopNode | SDFBlurCopNode;
					const spareParamNameBoundMin = `${nodePathParam.name()}BoundMin`;
					const spareParamNameBoundMax = `${nodePathParam.name()}BoundMax`;
					const spareParamBoundMin = node.params.spare.find(
						(spareParam) => spareParam.name() == spareParamNameBoundMin
					) as Vector3Param | undefined;
					const spareParamBoundMax = node.params.spare.find(
						(spareParam) => spareParam.name() == spareParamNameBoundMax
					) as Vector3Param | undefined;
					console.log({spareParamBoundMin, spareParamBoundMax});
					if (!(spareParamBoundMin && spareParamBoundMax)) {
						return;
					}
					const components: ['x', 'y', 'z'] = ['x', 'y', 'z'];
					// for now, I prefer NOT to use CHSOP, as the resulting expression will not update
					// if the refered SDFFromUrl or SDFFromObject has its bounds updated,
					// which would be really useful.
					const USE_CHSOP = false;
					if (USE_CHSOP) {
						spareParamBoundMin.set(
							components.map(
								(c) => `ch(chsop('${nodePathParam.name()}')+'/${sdfNode.p.boundMin[c].name()}')`
							) as [string, string, string]
						);
						spareParamBoundMax.set(
							components.map(
								(c) => `ch(chsop('${nodePathParam.name()}')+'/${sdfNode.p.boundMax[c].name()}')`
							) as [string, string, string]
						);
					} else {
						spareParamBoundMin.set(
							components.map(
								(c) => `ch('${nodePathParam.rawInput()}/${sdfNode.p.boundMin[c].name()}')`
							) as [string, string, string]
						);
						spareParamBoundMax.set(
							components.map(
								(c) => `ch('${nodePathParam.rawInput()}/${sdfNode.p.boundMax[c].name()}')`
							) as [string, string, string]
						);
					}
				}

				nodePathParams.forEach(_updateNodePathBoundParams);
			},
		};
		return [bindTextureSDFBounds];
	},
};
